module.exports = __webpack_public_path__ + "img/upsell-check-icon-white.svg";